<script>
   import Layout from '../../layouts/main'
   import PageHeader from '@/components/page-header'
   import appConfig from "@/app.config";
    
   export default {
      page: {
         title: "Add Fuel Station",
         meta: [
            {
               name: "description",
               content: appConfig.description,
            },
         ],
      },
      components: { Layout, PageHeader },
      data() {
         return {
            title: "Add Fuel Station",
            items: [
               {
                  text: "Fuel Stations",
                  href: "/fuel-stations",
               },
               {
                  text: "Add Fuel Station",
                  active: true,
               },        
            ],

            station: {
               name_en: '',
               name_so: '',
               country_code: 1,
               mobile: '',
               email: '',
               password: '',
               password_confirmation: '',
               place: '',
               latitude: '',
               longitude: '',
               address: '',
               bank_name: '',
               account_no: '',
               account_holder_name: '',
               account_type: '',
               ifsc_code: '',
               upi_id: '',
               deposite: '',
               branch: '',
            },

            station_location: '',
            station_marker: { position: { lat: null, lng: null } },
            station_center: { lat: null, lng: null },
            station_current_place: null,

            station_mapOptions: {
               disableDefaultUI: true,
            },

            image: "",
            preview_image: "",

            errors: {},
            token: '',

            country_codes: [],

         };
      },
      mounted() {
         this.fetchCountryCodes();
      },

      methods: {
         //sets the position of marker when dragged
         stationHandleMarkerDrag(e) {
            this.station_marker.position = { lat: e.latLng.lat(), lng: e.latLng.lng() };
         },

         //Moves the map view port to marker
         stationPanToMarker() {
            this.$refs.stationMapRef.panTo(this.station_marker.position);
            this.$refs.stationMapRef.setZoom(18);
         },

         //Moves the marker to click position on the map
         stationHandleMapClick(e) {
            this.station_marker.position = { lat: e.latLng.lat(), lng: e.latLng.lng() };
            console.log(e);
         },     

         stationSetPlace(place) {
            this.station_current_place = place;
            if(this.station_current_place) {
               const marker = {
                  lat: this.station_current_place.geometry.location.lat(),
                  lng: this.station_current_place.geometry.location.lng(),
               };
               this.station_center = marker;
               this.station_marker.position = marker;
               this.station_location = place.formatted_address;
            }
         },

         setFile(e) {
            this.image = e.target.files[0];
            this.preview_image = URL.createObjectURL(e.target.files[0]);
         },

         fetchCountryCodes() {
            let url = "api/get-countrycodes";         
            this.getToken();
            this.$axios
               .get(url, { headers: { Authorization: "Bearer " + this.token } })
               .then((res) => {
                  var responseData = res.data.data;
                  console.log(responseData);
                  this.country_codes = responseData.country_codes;
                  console.warn(responseData.country_codes);

               })
               .catch((err) => console.log(err));
         },

         getToken() {
            if (localStorage.getItem('sigofuel_admin')) {
               var sigofuel_admin =  JSON.parse(localStorage.getItem('sigofuel_admin'));
               if(sigofuel_admin.token) {
                  this.token = sigofuel_admin.token;
               } else {
                  this.$swal("", "Failed to fetch token, please login again", "error");
                  this.$router.push({ name: "login" });
               }
               
            } else {
               this.$swal("", "Session expired, please login again", "error");
               this.$router.push({ name: "login" });
            }
         }, 

         addFuelStation() {
            this.getToken();           
            
            const config = {
               headers: {
                  "Content-type": "multipart/form-data",
                  "Accept": "application/json",
                  "Authorization": "Bearer " + this.token,
               },
            };

            let url = "api/admin/fuelStation/add";

            let formData = new FormData();
            formData.append("name_en", this.station.name_en); 
            formData.append("name_so", this.station.name_so); 
            formData.append("place", this.station.place); 
            formData.append("country_code", this.station.country_code); 
            formData.append("mobile", this.station.mobile); 
            formData.append("email", this.station.email); 
            formData.append("latitude", this.station_marker.position.lat); 
            formData.append("longitude", this.station_marker.position.lng);
            formData.append("address", this.station.address); 
            formData.append("password", this.station.password); 
            formData.append("password_confirmation", this.station.password_confirmation); 
            formData.append("bank_name", this.station.bank_name); 
            formData.append("account_no", this.station.account_no); 
            formData.append("account_holder_name", this.station.account_holder_name); 
            formData.append("account_type", this.station.account_type); 
            formData.append("ifsc_code", this.station.ifsc_code); 
            formData.append("upi_id", this.station.upi_id); 
            formData.append("deposite", this.station.deposite); 
            formData.append("branch", this.station.branch); 

            formData.append('image', this.image);
           
            this.$axios
            .post(url, formData, config)
            .then((res) => {
               if(res.status == 200) {
                     this.$swal("", res.data.message, "success");
                     this.clearForm();
                     this.$router.push({ name: 'stations'});
               } else {
                     this.$swal("", "Something went wrong", "error");
               }
            })
            .catch((error) => {
               if (error.response) {
                  if(error.response.status == 422) {               
                     if (error.response.data) {
                        this.errors = error.response.data.message;
                     } 
                     this.$swal("", error.response.statusText, "error");
                     
                  } else if(error.response.status == 500) {
                     this.$swal("", error.response.statusText, "error");

                  } else if(error.response.status == 401) {
                     this.$swal("", error.response.statusText, "error");
                     this.$router.push({ name: "login" });
                     
                  } else {
                     this.$swal("", "Something went wrong", "error");
                  }
               } else {
                  this.$swal("", error.message, "error");
               }
            })
            .finally(() => (this.loading = false));
         },

         clearForm() {        
            this.station.name_en = "";
            this.station.name_so = "";
            this.station.place = "";
            this.station.country_code = "";
            this.station.mobile = "";
            this.station.email = "";
            this.station.latitude = "";
            this.station.longitude = "";
            this.station.address = "";
            this.station.password = "";
            this.station.password_confirmation = ""; 
            this.station.bank_name = "";
            this.station.account_no = ""; 
            this.station.account_holder_name = ""; 
            this.station.account_type = "";
            this.station.ifsc_code = "";
            this.station.upi_id = "";
            this.station.deposite = "";
            this.station.branch = "";
            
            this.errors = {};
         },
      }
   }
</script>
    
<template>
   <Layout>
      <PageHeader :title="title" :items="items" />
      <div class="row">
         <div class="col-12">
            <div class="card">
               <div class="card-body">

                  <!----- top button area starts---->
                  <div class="row mb-2">
                     <div class="col-12">
                        <router-link :to="{ name: 'stations' }" class="btn btn-primary float-end"><i class='bx bx-chevrons-left'></i> Back</router-link>
                     </div>
                  </div>
                  <!----- top button area ends---->
                  <form class="form-horizontal" role="form" @submit.prevent="addFuelStation()">
                     <b-card header-class="bg-transparent border-light" class="border border-light">
                     
                        <div class="row"> 

                           <b-form-group class="col-lg-6 mb-3">
                              <label>Name (English) <span class="text-danger">*</span></label>
                              <b-form-input v-model="station.name_en" v-bind:class="{ 'is-invalid': Boolean(errors.name_en) }" maxlength="255"></b-form-input>
                              <div v-for="(val, index) in errors.name_en" :key="index" class="invalid-feedback">
                                 <p class="mb-0">{{ val }}</p>
                              </div>
                           </b-form-group>

                           <b-form-group class="col-lg-6 mb-3">
                              <label>Name (Somali) <span class="text-danger">*</span></label>
                              <b-form-input v-model="station.name_so" v-bind:class="{ 'is-invalid': Boolean(errors.name_so) }" maxlength="255"></b-form-input>
                              <div v-for="(val, index) in errors.name_so" :key="index" class="invalid-feedback">
                                 <p class="mb-0">{{ val }}</p>
                              </div>
                           </b-form-group>

                           <b-form-group class="col-lg-6 mb-3">
                              <label>Place <span class="text-danger">*</span></label>
                              <b-form-input v-model="station.place" v-bind:class="{ 'is-invalid': Boolean(errors.place) }" maxlength="255"></b-form-input>
                              <div v-for="(val, index) in errors.place" :key="index" class="invalid-feedback">
                                 <p class="mb-0">{{ val }}</p>
                              </div>
                           </b-form-group>

                           <b-form-group class="col-lg-6 mb-3">
                              <label>Mobile <span class="text-danger">*</span></label>
                              <b-input-group>
                                 <b-input-group-prepend>
                                    <select class="form-control" v-model="station.country_code">
                                       <option :value="country_code.id" v-for="country_code in country_codes" :key="country_code.id">{{country_code.country_code}}</option>
                                    </select>
                                 </b-input-group-prepend>
                                 <b-form-input v-model="station.mobile" v-bind:class="{ 'is-invalid': Boolean(errors.mobile) }"></b-form-input>

                                 <div v-for="(val, index) in errors.mobile" :key="index" class="invalid-feedback">
                                    <p class="mb-0">{{ val }}</p>
                                 </div>
                              </b-input-group>
                           </b-form-group>

                           <b-form-group class="col-lg-6 mb-3">
                              <label>Email</label>
                              <b-form-input type="email" v-model="station.email" v-bind:class="{ 'is-invalid': Boolean(errors.email) }"></b-form-input>

                              <div v-for="(val, index) in errors.email" :key="index" class="invalid-feedback">
                                    <p class="mb-0">{{ val }}</p>
                              </div>
                           </b-form-group>                          

                           
                           <b-form-group class="col-lg-6 mb-3">
                              <label>Password <span class="text-danger">*</span></label>
                              <b-form-input type="password" v-model="station.password" v-bind:class="{ 'is-invalid': Boolean(errors.password) }"></b-form-input>

                              <div v-for="(val, index) in errors.password" :key="index" class="invalid-feedback">
                                 <p class="mb-0">{{ val }}</p>
                              </div>
                           </b-form-group>

                           <b-form-group class="col-lg-6 mb-3">
                              <label>Confirm Password <span class="text-danger">*</span></label>
                              <b-form-input type="password" v-model="station.password_confirmation" v-bind:class="{ 'is-invalid': Boolean(errors.password_confirmation) }"></b-form-input>

                              <div v-for="(val, index) in errors.password_confirmation" :key="index" class="invalid-feedback">
                                 <p class="mb-0">{{ val }}</p>
                              </div>
                           </b-form-group>

                           <b-col md="12" class="mb-3">
                              <label class="control-label">Location <span class="text-danger">*</span></label>
                              <GmapAutocomplete @place_changed="stationSetPlace" class="form-control"  @keypress.enter="$event.preventDefault()" placeholder="Search here to pick the required latitude and longitude..."  :value="station_location"/>
                              
                              <GmapMap v-if="station_location"
                                 :center="station_center"
                                 :zoom="18"
                                 map-style-id="station-roadmap"
                                 :options="station_mapOptions"
                                 style="width: 100%; height: 50vmin"
                                 ref="stationMapRef"
                                 @click="stationHandleMapClick">
                                    <GmapMarker
                                       :position="station_marker.position"
                                       :clickable="true"
                                       :draggable="true"
                                       @drag="stationHandleMarkerDrag"
                                       @click="stationPanToMarker"
                                    />
                              </GmapMap>                          
                           </b-col>

                           <b-col md="6" xl="6" class="form-group">
                              <label class="control-label">Latitude <span class="text-danger">*</span></label>
                              <b-form-input v-model="station_marker.position.lat" v-bind:class="{ 'is-invalid': Boolean(errors.latitude) }"></b-form-input>

                              <div v-for="(val, index) in errors.latitude" :key="index" class="invalid-feedback">
                                 <p class="mb-0">{{ val }}</p>
                              </div>
                              
                           </b-col>

                           <b-col md="6" xl="6" class="form-group">
                              <label class="control-label">Longitude <span class="text-danger">*</span></label>
                              <b-form-input v-model="station_marker.position.lng" v-bind:class="{ 'is-invalid': Boolean(errors.longitude) }"></b-form-input>

                              <div v-for="(val, index) in errors.longitude" :key="index" class="invalid-feedback">
                                 <p class="mb-0">{{ val }}</p>
                              </div>
                              
                           </b-col>

                           <b-form-group class="col-lg-6 mb-3">
                              <label>Deposit <span class="text-danger">*</span></label>
                              <b-form-input type="number" min="1" v-model="station.deposite" v-bind:class="{ 'is-invalid': Boolean(errors.deposite) }" maxlength="255"></b-form-input>
                              <div v-for="(val, index) in errors.deposite" :key="index" class="invalid-feedback">
                                 <p class="mb-0">{{ val }}</p>
                              </div>
                           </b-form-group>

                           <b-col md="6" xl="6" class="form-group">
                              <label>Address <span class="text-danger">*</span></label>
                              <textarea rows="2" v-model="station.address" class="form-control" v-bind:class="{ 'is-invalid': Boolean(errors.address) }"></textarea>

                              <div v-for="(val, index) in errors.address" :key="index" class="invalid-feedback">
                                 <p class="mb-0">{{ val }}</p>
                              </div>
                           </b-col>

                           <b-form-group class="col-lg-6 mb-3">                              
                              <label>Profile Image  <span class="small">[Allowed formats: .jpg, .jpeg, .png]</span></label>                            
                              <input type="file" @change="setFile($event)" accept=".png,.jpg,.jpeg" class="form-control" :class="{ 'is-invalid': Boolean(errors.image) }" />
                              <img v-if="preview_image" class="avatar-sm mt-2" :src="preview_image">

                              <div v-for="(val, index) in errors.image" :key="index" class="invalid-feedback">
                                 <p class="mb-0">{{ val }}</p>
                              </div>
                           </b-form-group>
                           
                        </div>                        
                     
                     </b-card>
                  
                     <b-card header-class="bg-transparent border-light" class="border border-light">
                        <div class="row"> 
                           <h4 class="font-size-16 mb-3">Bank Details</h4>
                           <b-form-group class="col-lg-6 mb-3">
                              <label>Account No. <span class="text-danger">*</span></label>
                              <b-form-input v-model="station.account_no" v-bind:class="{ 'is-invalid': Boolean(errors.account_no) }"></b-form-input>

                              <div v-for="(val, index) in errors.account_no" :key="index" class="invalid-feedback">
                                 <p class="mb-0">{{ val }}</p>
                              </div>
                           </b-form-group> 

                           <b-form-group class="col-lg-6 mb-3">
                              <label>Bank Name <span class="text-danger">*</span></label>
                              <b-form-input v-model="station.bank_name" v-bind:class="{ 'is-invalid': Boolean(errors.bank_name) }"></b-form-input>

                              <div v-for="(val, index) in errors.bank_name" :key="index" class="invalid-feedback">
                                 <p class="mb-0">{{ val }}</p>
                              </div>
                           </b-form-group> 

                           <b-form-group class="col-lg-6 mb-3">
                              <label>Account Holder Name <span class="text-danger">*</span></label>
                              <b-form-input v-model="station.account_holder_name" v-bind:class="{ 'is-invalid': Boolean(errors.account_holder_name) }"></b-form-input>

                              <div v-for="(val, index) in errors.account_holder_name" :key="index" class="invalid-feedback">
                                 <p class="mb-0">{{ val }}</p>
                              </div>
                           </b-form-group>   

                           <b-form-group class="col-lg-6 mb-3">
                              <label>Branch <span class="text-danger">*</span></label>
                              <b-form-input v-model="station.branch" v-bind:class="{ 'is-invalid': Boolean(errors.branch) }"></b-form-input>

                              <div v-for="(val, index) in errors.branch" :key="index" class="invalid-feedback">
                                 <p class="mb-0">{{ val }}</p>
                              </div>
                           </b-form-group>   

                           <b-form-group class="col-lg-6 mb-3">
                              <label>IFSC Code <span class="text-danger">*</span></label>
                              <b-form-input v-model="station.ifsc_code" v-bind:class="{ 'is-invalid': Boolean(errors.ifsc_code) }"></b-form-input>

                              <div v-for="(val, index) in errors.ifsc_code" :key="index" class="invalid-feedback">
                                 <p class="mb-0">{{ val }}</p>
                              </div>
                           </b-form-group>   

                           <b-form-group class="col-lg-6 mb-3">
                              <label>Account Type <span class="text-danger">*</span></label>
                              <select class="form-control" v-model="station.account_type" v-bind:class="{ 'is-invalid': Boolean(errors.account_type) }">
                                 <option value="">Select</option>
                                 <option value="1">Savings Account</option>
                                 <option value="2">Current Account</option>
                              </select>

                              <div v-for="(val, index) in errors.account_type" :key="index" class="invalid-feedback">
                                 <p class="mb-0">{{ val }}</p>
                              </div>
                           </b-form-group>       

                           <b-form-group class="col-lg-6 mb-3">
                              <label>UPI ID <span class="text-danger">*</span></label>
                              <b-form-input v-model="station.upi_id" v-bind:class="{ 'is-invalid': Boolean(errors.upi_id) }"></b-form-input>

                              <div v-for="(val, index) in errors.upi_id" :key="index" class="invalid-feedback">
                                 <p class="mb-0">{{ val }}</p>
                              </div>
                           </b-form-group>                
                          
                        </div>
                     </b-card>
                     <div class="row mt-3">
                        <div class="12">
                           <button class="btn btn-primary me-2" type="submit">Save</button>
                           <router-link :to="{ name: 'stations' }" class="btn btn-light">Cancel</router-link>
                        </div>
                     </div>
                  </form>
               </div>
            </div>
         </div>
      </div>
   </Layout>
</template>
